// src/api/auth/service.js
import { json } from "utils/http/client";

// Django REST Framework SimpleJWT style endpoints
export const SettingsAPI = {
    login: ({ email, password }) =>
        json("/auth/login/", { method: "POST", body: { email, password } }),
    getUserProfile: () => json("/auth/user-details-of-user/", {
        method: "GET"
    }),
    updateUserDetails: (userId, data) => json(`/auth/update-userdetails/${userId}/`, {
        method: "PATCH",
        body: data
    }),
    getAddress: (addressId) => json(`/auth/get-address/${addressId}/`, {
        method: "GET"
    }),
    createAddress: (data) => json("/auth/create-address/", {
        method: "POST",
        body: data
    }),
    updateAddress: (addressId, data) => json(`/auth/update-address/${addressId}/`, {
        method: "PATCH",
        body: data
    }),

    //organization APIs
    getOrganization: (organizationId) =>
        json(`/org/get-a-organization/${organizationId}/`, { method: "GET" }),
    updateOrganization: (organizationId, data) =>
        json(`/org/update-organization/${organizationId}/`, {
            method: "PATCH",
            body: data,
        }),
    createOrganizationSearchIndex: (data) =>
        json("/core/azure-search/create-index/", {
            method: "POST",
            body: data,
        }),
    pushOrganizationSearchData: (data) =>
        json("/core/azure-search/push-data/", {
            method: "POST",
            body: data,
        }),
    deleteUser: (userId) => json(`/auth/delete-user/${userId}/`, {
        method: "DELETE"
    }),
    getAIServiceStatus: (orgId) =>
        json(`/core/azure-search/${orgId}/status/`, { method: "GET" }),
    getLastSyncStatus: (orgId) =>
        json(`/core/azure-search/${orgId}/last-sync/`, { method: "GET" }),
};
